import type { TRuleWithTheme } from 'styles/theme';

export const clearIcon: TRuleWithTheme = ({ theme: { colors } }) => ({
    width: 18,
    height: 18,
    color: colors.buttonEnabledText,
});
